import React from 'react'

import { useJourneyDevTools } from '@cash-web/shared-devtools-data-access-context'
import { useJourneyContext } from '@cash-web/shared-journey-data-access-context'

import { CommandK } from './index'

/**
 * Bridge component that renders CommandK only when both journey context
 * and journey dev tools are available. This allows DevTools to be at the
 * highest level while CommandK gets the journey data it needs.
 */
export const CommandKJourneyBridge = () => {
  const journeyContext = useJourneyContext()
  const journeyDevTools = useJourneyDevTools()

  // Only render CommandK if we have both journey context and routes data
  if (!journeyContext || !journeyDevTools?.routes) {
    return null
  }

  return <CommandK />
}
